import React from 'react';
import { COLORES, etiquetasDelChat } from '../../utils/etiquetasDeChat';

/**
 * Las etiquetas propias de un chat (punto 11): sólo las que siguen en el catálogo, en su orden. Un id que ya no
 * está (una etiqueta borrada cuya limpieza no terminó) no se pinta.
 */
export default function ChipsDeEtiquetas({ chat, catalogo, estilo }) {
  const lista = etiquetasDelChat(chat, catalogo);
  if (!lista.length) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', marginBottom: '0.6rem', ...estilo }}>
      {lista.map((e) => {
        const color = COLORES[e.color] || COLORES.gris;
        return (
          <span
            key={e.id}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '0.3rem',
              padding: '0.15rem 0.55rem', borderRadius: '999px',
              border: `1px solid ${color}`, color, backgroundColor: '#fff',
              fontSize: '12px', fontWeight: 600, maxWidth: '100%',
            }}
          >
            <span aria-hidden="true" style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: color, flexShrink: 0 }} />
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.nombre}</span>
          </span>
        );
      })}
    </div>
  );
}
